import React, { useEffect } from "react";

function useScrollReveal() {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => entries.forEach((e) => e.isIntersecting && e.target.classList.add("sr-visible")),
      { threshold: 0.12 }
    );
    document.querySelectorAll(".sr").forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);
}

const OurStory = () => {
  useScrollReveal();

  return (
    <div className="min-h-screen bg-gray-50 py-20">
      <div className="max-w-5xl mx-auto px-6">

        <div className="sr text-center mb-14">
          <h1 className="text-4xl font-bold mb-3">Our Story</h1>
          <div className="w-20 h-1 bg-primary rounded-full mx-auto mt-4" />
        </div>

        <div className="space-y-6 max-w-3xl mx-auto">
          <p className="sr text-gray-700 text-lg leading-relaxed" style={{ transitionDelay: "0.1s" }}>
            Igembe South Constituency Bursary was established to support students
            from secondary schools, colleges, and universities in accessing education.
            The goal is to make bursary applications efficient, transparent, and inclusive,
            especially for students who may not have access to smartphones or email.
          </p>
          <p className="sr text-gray-700 text-lg leading-relaxed" style={{ transitionDelay: "0.2s" }}>
            By leveraging technology, the system reduces manual paperwork, ensures
            fair verification, and enables students to track the status of their applications.
            Every eligible student can now submit their personal, academic, and guardian
            details securely and efficiently.
          </p>
        </div>
      </div>

      <style>{`
        .sr { opacity: 0; transform: translateY(20px); transition: opacity 0.55s ease, transform 0.55s ease; }
        .sr-visible { opacity: 1; transform: translateY(0); }
      `}</style>
    </div>
  );
};

export default OurStory;